import { Plan, SubscriptionStatus, SubscriptionType } from './plan.types';

export enum CompanyTabType {
  ALL = 'all',
  ENTERPRISE_REQUEST = 'enterprise-request',
  SUBSCRIPTION = 'subscription',
}

export const CompanyTabTitle: Record<CompanyTabType, string> = {
  [CompanyTabType.ALL]: 'All',
  [CompanyTabType.ENTERPRISE_REQUEST]: 'Enterprise Request',
  [CompanyTabType.SUBSCRIPTION]: 'Subscription',
};

export const arrayOfCompanyTab = Object.entries(CompanyTabTitle);

export type CompanyAllPlanFilter = 'all' | SubscriptionType;

export const CompanyPlanFilterTitle: Record<CompanyAllPlanFilter, string> = {
  all: 'All',
  [SubscriptionType.GROWTH]: 'Growth',
  [SubscriptionType.START_UP]: 'Startup',
  [SubscriptionType.ENTERPRISE]: 'Enterprise',
};

export const arrayOfCompanyPlanFilter = Object.entries(CompanyPlanFilterTitle);

export enum CompanyFreqFilter {
  MONTH = 'month',
  YEAR = 'year',
}

export type CompanyAllFreqFilter = 'all' | CompanyFreqFilter;

export const CompanyFreqFilterTitle: Record<CompanyAllFreqFilter, string> = {
  all: 'All',
  [CompanyFreqFilter.MONTH]: 'Monthly',
  [CompanyFreqFilter.YEAR]: 'Annually',
};

export const arrayOfCompanyFreqFilter = Object.entries(CompanyFreqFilterTitle);

export type CompanyAllPaymentFilter = 'all' | SubscriptionStatus;

export const CompanyPaymentFilterTitle: Record<CompanyAllPaymentFilter, string> = {
  all: 'All',
  [SubscriptionStatus.INCOMPLETE]: 'Incomplete',
  [SubscriptionStatus.INCOMPLETE_EXPIRED]: 'Incomplete expired',
  [SubscriptionStatus.TRIALING]: 'Trialing',
  [SubscriptionStatus.ACTIVE]: 'Active',
  [SubscriptionStatus.PAST_DUE]: 'Past due',
  [SubscriptionStatus.CANCELED]: 'Canceled',
  [SubscriptionStatus.UNPAID]: 'Unpaid',
};

export const arrayOfCompanyPaymentFilter = Object.entries(CompanyPaymentFilterTitle);

export enum CompanyOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum CompanySortBy {
  NAME = 'name',
  NEXT_PAYMENT = 'nextPayment',
  PLAN_FREQUENCY = 'planFrequency',
  PLAN_TYPE = 'planType',
  STAKEHOLDERS_COUNT = 'stakeholdersCount',
  STATUS = 'isActive',
  SUBSCRIPTION_STATUS = 'subscriptionStatus',
}

export enum CompanyIndustry {
  ACCOUNTING = 'accounting',
  AEROSPACE = 'aerospace',
  AGRICULTURE_FARMING = 'agriculture-farming',
  ART = 'art',
  ARTIFICIAL_INTELLIGENCE = 'artificial-intelligence',
  AUDIT = 'audit',
  AUTOMOTIVE = 'automotive',
  AVIATION = 'aviation',
  BANKING_FINANCIAL_SERVICES = 'banking-financial-services',
  BIOTECHNOLOGY = 'biotechnology',
  BUILDING_MATERIALS_SUPPLIES = 'building-materials-supplies',
  BUSINESS_SERVICES = 'business-services',
  CHEMICAL_INDUSTRY = 'chemical-industry',
  CLEANING_PRODUCTS_SERVICES = 'cleaning-products-services',
  CLOUD_COMPUTING = 'cloud-computing',
  COMPUTER_HARDWARE = 'computer-hardware',
  CONSTRUCTION = 'construction',
  CONSULTING = 'consulting',
  CONSUMER_ELECTRONICS = 'consumer-electronics',
  CONSUMER_GOODS = 'consumer-goods',
  CONSUMER_HEALTHCARE = 'consumer-healthcare',
  CULTURE = 'culture',
  CYBERSECURITY = 'cybersecurity',
  DATA_ANALYTICS = 'data-analytics',
  DATA_STORAGE_MANAGEMENT = 'data-storage-management',
  DEFENSE = 'defense',
  E_COMMERCE = 'e-commerce',
  EDUCATION_TRAINING = 'education-training',
  ELECTRIC_VEHICLES = 'electric-vehicles',
  ENERGY = 'energy',
  ENTERTAINMENT = 'entertainment',
  ENVIRONMENTAL_SERVICES = 'environmental-services',
  ESPORTS = 'esports',
  EVENTS = 'events',
  FABRICS_TEXTILES = 'fabrics-textiles',
  FASHION = 'fashion',
  FINTECH = 'fintech',
  FOOD_BEVERAGES = 'food-beverages',
  GOVERNMENT_PUBLIC_INSTITUTIONS = 'government-public-institutions',
  HEALTHCARE = 'healthcare',
  HOSPITALITY = 'hospitality',
  HR_TECH = 'hr-tech',
  IGAMING = 'igaming',
  INFORMATION_TECHNOLOGIES = 'information-technologies',
  INSURANCE = 'insurance',
  INTERNET_OF_THINGS = 'internet-of-things',
  LEGAL = 'legal',
  LEGAL_COMPLIANCE = 'legal-compliance',
  LEISURE_RECREATION = 'leisure-recreation',
  LOGISTICS_SUPPLY_CHAIN = 'logistics-supply-chain',
  LUXURY_GOODS = 'luxury-goods',
  MACHINERY_HEAVY_EQUIPMENT = 'machinery-heavy-equipment',
  MANUFACTURING = 'manufacturing',
  MARKETING_ADVERTISING = 'marketing-advertising',
  MEDIA = 'media',
  MEDICAL_DEVICES_SUPPLIES = 'medical-devices-supplies',
  MINING = 'mining',
  MOBILITY_TRANSPORTATION = 'mobility-transportation',
  MUSIC = 'music',
  NON_PROFIT = 'non-profit',
  OTHER = 'other',
  PERSONAL_SERVICES = 'personal-services',
  PET_CARE_SUPPLIES = 'pet-care-supplies',
  PHARMACEUTICALS = 'pharmaceuticals',
  PROFESSIONAL_SERVICES = 'professional-services',
  PUBLISHING = 'publishing',
  REAL_ESTATE_PROPTECH = 'real-estate-proptech',
  RESTAURANTS_FOOD_SERVICES = 'restaurants-food-services',
  RETAIL = 'retail',
  ROBOTICS = 'robotics',
  SMART_CITY = 'smart-city',
  SOCIAL_MEDIA = 'social-media',
  SOFTWARE_DEVELOPMENT = 'software-development',
  SPORTS_FITNESS = 'sports-fitness',
  TAX = 'tax',
  TELECOM_CONNECTIVITY = 'telecom-connectivity',
  TRAVEL_TOURISM = 'travel-tourism',
  VIDEO_GAMES = 'video-games',
  WASTE_MANAGEMENT = 'waste-management',
}
export enum CompanyType {
  COMPANY = 'company',
  FAMILY_OFFICE = 'family-office',
  OTHER = 'other',
  PRIVATE_EQUITY = 'private-equity',
  SPV = 'spv',
  VENTURE_CAPITAL = 'venture-capital',
}
export enum CompanyAnnualRevenue {
  BETWEEN_1_5_MIL = 'between-1-5-mil',
  BETWEEN_5_20_MIL = 'between-5_20-mil',
  LESS_1_MIL = 'less-1-mil',
  MORE_20_MIL = 'more-20-mil',
  NO_REV = 'no-rev',
}
export enum CompanyNumberOfEmployees {
  BETWEEN_1_10 = '1-10',
  BETWEEN_11_25 = '11-25',
  BETWEEN_26_50 = '26-50',
  BETWEEN_51_250 = '51-250',
  MORE_250 = '>250',
}

export type DocusignEnvelope = {
  hasOverride: boolean;
  limit: number;
  periodStart: null | string;
  remaining: number;
  used: number;
};

export type Company = {
  address?: string;
  adminEmail?: string;
  adminName?: string;
  annualRevenue?: CompanyAnnualRevenue;
  city?: string;
  companyId?: string;
  countryName?: string;
  createdAt?: string;
  currencyName?: string;
  docusignEnvelope?: DocusignEnvelope;
  id: string;
  industry?: CompanyIndustry;
  investorsCount?: number;
  isActive: boolean;
  isCompleted: boolean;
  isEnterpriseRequested?: boolean;
  isFirstSubscribed: boolean;
  lastInvoiceLink?: string;
  latestSubscriptionData: { created: number; plan?: Plan };
  logoImgSrc?: string;
  name: string;
  nav?: number;
  nextPayment?: number;
  numberOfEmployees?: CompanyNumberOfEmployees;
  planFrequency?: CompanyFreqFilter;
  planId?: string;
  planType?: SubscriptionType;
  stakeholdersCount?: number;
  stakeholdersLimit?: number;
  stateName?: string;
  stripeSubscriptionId?: string;
  subscriptionOfferLink?: string;
  subscriptionStatus?: SubscriptionStatus;
  toCancelAt?: string;
  totalInvestment?: number;
  type?: CompanyType;
  url?: string;
  zipCode?: string;
};

export enum NumberOfFetchedItems {
  FIVE = '5',
  TEN = '10',
  TWENTY = '20',
  FIFTY = '50', // eslint-disable-line
}

export type SelectNumberOfFetchedItems = NumberOfFetchedItems;

export const selectVariant = Object.values(NumberOfFetchedItems);

export enum FilterType {
  BY_FREQ = 'by-freq',
  BY_PAYMENT = 'by-payment',
  BY_TYPE = 'by-type',
}
